import {Controller} from "@hotwired/stimulus";
import $ from 'jquery';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static values = {
        url: String,
    };

    static targets = [
        'litigantInput',
        'filterFrom',
        'filterTo',
        'exportFrom',
        'exportTo',
    ];

    submitStatus(event) {
        event.preventDefault();

        let selectedValue = $('#payment-status-filter').find(":selected").val();
        let redirectUrl = new URL(this.urlValue);

        if ("all" === selectedValue) {
            redirectUrl.searchParams.delete('status');
        } else {
            redirectUrl.searchParams.set('status', selectedValue);
        }

        redirectUrl.searchParams.delete('page');

        window.location = redirectUrl;
    }

    submitDate(event) {
        event.preventDefault();

        let redirectUrl = new URL(this.urlValue);

        redirectUrl.searchParams.set('filter-from', this.filterFromTarget.value);
        redirectUrl.searchParams.set('filter-to', this.filterToTarget.value);
        redirectUrl.searchParams.delete('page');

        window.location = redirectUrl;
    }

    submitSearch(event) {
        event.preventDefault();

        let selectedLitigantId = this.litigantInputTarget.value;
        let redirectUrl = new URL(this.urlValue);

        redirectUrl.searchParams.set('search-litigant', selectedLitigantId);
        redirectUrl.searchParams.delete('page');

        window.location = redirectUrl;
    }
}
